import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { loginUser } from '../../../../src/services/authService';
import Loader from '../../loader/loader';
import { useToast } from '../../../Toaster/ToastContext';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../../core/redux/action';

const Signin = () => {
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const route = all_routes;

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [formErrors, setFormErrors] = useState({ username: '', password: '' });
  const [touched, setTouched] = useState({ username: false, password: false });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const errors = { username: '', password: '' };
    let isValid = true;

    // Email validation
    if (!username) {
      errors.username = 'Email is required';
      isValid = false;
    }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username)) {
      errors.username = 'Please enter a valid email address';
      isValid = false;
    }

    // Password validation
    if (!password) {
      errors.password = 'Password is required';
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleInputBlur = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }));
    validateForm();
  };

  const handleInputChange = (field, value, setter) => {
    setter(value);
    setTouched(prev => ({ ...prev, [field]: true }));
    validateForm();
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const checkPermissionForPath = (rolesPermissions, path) => {
    try {
      const parsedData = JSON.parse(rolesPermissions);

      const permissionData = JSON.parse(parsedData.permissions);
      const permissions = permissionData.permissions;

      if (!Array.isArray(permissions)) {
        console.error('Permissions is not an array:', permissions);
        return false;
      }

      const searchPermissions = (items) => {
        if (!Array.isArray(items)) {
          return false;
        }
        return items.some(item => {
          if (item.url && item.url === path && item.enabled) {
            return true;
          }
          if (item.childPage && Array.isArray(item.childPage)) {
            return searchPermissions(item.childPage);
          }
          return false;
        });
      };

      return searchPermissions(permissions);
    } catch (error) {
      console.error('Error parsing rolespermissions:', error);
      return false;
    }
  };

  const checkAuthStatus = () => {
    const token = localStorage.getItem('authToken');
    const userType = localStorage.getItem('user_type');
    const rolesPermissions = localStorage.getItem('rolespermissions');
    const lastVisitedPath = localStorage.getItem('lastVisitedPath');
    const userData = {
      token,
      user_type: userType,
      business_id: localStorage.getItem('business_id'),
      name: localStorage.getItem('name'),
      branch_name: localStorage.getItem('branch'),
      branch_id: localStorage.getItem('branch_id'),
      rolespermissions: rolesPermissions ? JSON.parse(rolesPermissions) : null,
    };

    if (token && userType) {
      dispatch(setUserData(userData));
      if (userType === "owner") {
        navigate('/admin-dashboard');
      } else if (lastVisitedPath && checkPermissionForPath(rolesPermissions, lastVisitedPath)) {
        navigate(lastVisitedPath);
      } else {
        navigate('/pos');
      }
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ username: true, password: true });
    if (validateForm()) {
      setLoading(true);
      try {
        const result = await loginUser(username, password);
        const Apidata = await result.json();
        if (Apidata.success) {
          const token = Apidata?.data.token;
          if (token) {
            localStorage.setItem('authToken', token);
            localStorage.setItem('business_id', Apidata?.data.business_id);
            localStorage.setItem('user_type', Apidata?.data.user_type);
            localStorage.setItem('name', Apidata?.data.name);
            if (Apidata?.data.branch_name) {
              localStorage.setItem('branch', Apidata?.data.branch_name);
              localStorage.setItem('branch_id', Apidata?.data.branch_id);
            }
            localStorage.setItem('rolespermissions', JSON.stringify(Apidata?.data.rolespermissions));
            dispatch(setUserData(Apidata.data));
            setError('');
            setLoading(false);
            showToast("Login successful! Welcome back.", "success", "Sign In");

            const userType = Apidata?.data.user_type;
            const rolesPermissions = localStorage.getItem('rolespermissions');
            const lastVisitedPath = localStorage.getItem('lastVisitedPath');

            if (userType === "owner") {
              navigate('/admin-dashboard');
            } 
            else if (lastVisitedPath && checkPermissionForPath(rolesPermissions, lastVisitedPath)) {
              navigate(lastVisitedPath);
            } 
            else {
              navigate('/pos');
            }
          }
        } else {
          setLoading(false);
          const errorMessage = Apidata.error || 'Login failed. Please try again.';
          setError(errorMessage);
          setUsername('');
          setPassword('');
        }
      } catch (error) {
        setLoading(false);
        setError(error.message || 'An unexpected error occurred: Please contact the support team.');
        showToast(error.message || 'Login failed. Please try again.', 'error', 'Sign In');
        setUsername('');
        setPassword('');
      }
    }
  };

  return (
    <div className="main-wrapper">
      <Loader loading={loading} />
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-content">
            <form onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="https://odabill.com/assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="https://odabill.com/assets/img/logo-white.png" alt="img" />
                </Link>
                <div className="login-userheading">
                  <h3>Sign In</h3>
                  <h4>
                    Access the Odabill panel using your email and passcode.
                  </h4>
                </div>
                {/* Error Message */}
                {error && (
                  <div style={{
                    color: 'red',
                    backgroundColor: '#fdebeb',
                    padding: '10px 6px',
                    marginBottom: '10px',
                    borderRadius: '5px',
                    border: '1px solid red'
                  }}>
                    {error}
                  </div>
                )}
                <div className="form-login mb-3">
                  <label className="form-label">Email Address</label>
                  <div className="form-addons">
                    <input type="text" className="form- control" value={username}
                      onChange={(e) => handleInputChange('username', e.target.value, setUsername)} onBlur={() => handleInputBlur('username')}
                    />
                    <ImageWithBasePath
                      src="https://odabill.com/assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                  {touched.username && formErrors.username && (
                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                      {formErrors.username}
                    </div>
                  )}
                </div>
                <div className="form-login mb-3">
                  <label className="form-label">Password</label>
                  <div className="pass-group">
                    <input className="pass-input form-control"
                      type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => handleInputChange('password', e.target.value, setPassword)}
                      onBlur={() => handleInputBlur('password')}
                    />
                    {/* <span className="fas toggle-password fa-eye-slash" /> */}
                    <span
                      className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                  {touched.password && formErrors.password && (
                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                      {formErrors.password}
                    </div>
                  )}
                </div>
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="custom-control custom-checkbox">
                        {/* <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" className="form-control" />
                          <span className="checkmarks" />
                          Remember me
                        </label> */}
                      </div>
                      <div className="text-end">
                        <Link className="forgot-link" to={route.forgotPassword}>
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    Sign In
                  </button>
                </div>
                {/* <div className="signinform">
                  <h4>
                    New on our platform?
                    <Link to={route.register} className="hover-a">
                      {" "}
                      Create an account
                    </Link>
                  </h4>
                </div> */}
                {/* <div className="form-setlogin or-text">
                  <h4>OR</h4>
                </div>
                <div className="form-sociallink">
                  <ul className="d-flex">
                    <li>
                      <Link to="#" className="facebook-logo">
                        <ImageWithBasePath
                          src="https://odabill.com/assets/img/icons/facebook-logo.svg"
                          alt="Facebook"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath
                          src="https://odabill.com/assets/img/icons/google.png"
                          alt="Google"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="apple-logo">
                        <ImageWithBasePath
                          src="https://odabill.com/assets/img/icons/apple-logo.svg"
                          alt="Apple"
                        />
                      </Link>
                    </li>
                  </ul>
                  <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                    <p>Copyright © 2023 DreamsPOS. All rights reserved</p>
                  </div>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
